export default "__VITE_ASSET__Dpi7VxHU__"